import { obterLimitesAsync, obterUsuariosAsync } from "../../services/limiteService";

const atualizarLimites = async ({ commit }) => {
    const limites = await obterLimitesAsync();
    commit('atualizarLimites', limites);
}

const atualizarUsuariosLimite = async ({ commit }) => {
    const usuariosLimite = await obterUsuariosAsync();
    commit('atualizarUsuariosLimite', usuariosLimite);
}

const atualizarLimite = ({ commit }, limite) => {
    commit('atualizarLimite', limite);
}

export default {
    atualizarLimites,
    atualizarLimite,
    atualizarUsuariosLimite
}